export default {
    'please-select-a-filter': 'Please select a filter',
    customers: 'Customers',
    'external-entities': 'External entities',
    staff: 'Staff',
    input: 'Input',
    output: 'Outout',
    "total-sales": "Total sales"
}